/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Write_Long_ContentInputs */



/**
* | output |
* | --- |
* | "Help me write a longer text" |
*
* @param {Uno_Welcome_Suggestion_Write_Long_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_write_long_content = /** @type {((inputs?: Uno_Welcome_Suggestion_Write_Long_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Write_Long_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hilf mir, einen längeren Text zu schreiben")
	return /** @type {LocalizedString} */ ("Help me write a longer text")
});